var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10532_298865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 8.66732L6.66406 10.6673L11.3307 5.33398",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29167 2.57747C5.65986 2.57747 5.95833 2.279 5.95833 1.91081C5.95833 1.54262 5.65986 1.24414 5.29167 1.24414C4.92348 1.24414 4.625 1.54262 4.625 1.91081C4.625 2.279 4.92348 2.57747 5.29167 2.57747Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04948 4.20638C3.41767 4.20638 3.71615 3.9079 3.71615 3.53971C3.71615 3.17152 3.41767 2.87305 3.04948 2.87305C2.68129 2.87305 2.38281 3.17152 2.38281 3.53971C2.38281 3.9079 2.68129 4.20638 3.04948 4.20638Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65885 6.60677C2.02704 6.60677 2.32552 6.30829 2.32552 5.9401C2.32552 5.57191 2.02704 5.27344 1.65885 5.27344C1.29066 5.27344 0.992188 5.57191 0.992188 5.9401C0.992188 6.30829 1.29066 6.60677 1.65885 6.60677Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36979 9.36458C1.73798 9.36458 2.03646 9.06611 2.03646 8.69792C2.03646 8.32973 1.73798 8.03125 1.36979 8.03125C1.0016 8.03125 0.703125 8.32973 0.703125 8.69792C0.703125 9.06611 1.0016 9.36458 1.36979 9.36458Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22917 12.0013C2.59736 12.0013 2.89583 11.7028 2.89583 11.3346C2.89583 10.9664 2.59736 10.668 2.22917 10.668C1.86098 10.668 1.5625 10.9664 1.5625 11.3346C1.5625 11.7028 1.86098 12.0013 2.22917 12.0013Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99679 1.33398C11.6788 1.33398 14.6635 4.31865 14.6635 8.00065C14.6635 11.6827 11.6788 14.6673 7.99679 14.6673C6.53212 14.6673 5.17813 14.1953 4.07812 13.3947",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10532_298865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskView);
export default __webpack_public_path__ + "static/media/task-view.7ca412e468afebbe660fbd05bcf82065.svg";
export { ForwardRef as ReactComponent };